// // // document.addEventListener('DOMContentLoaded', function () {
// // //   console.log('[custom.js] loaded');

// // //   const variantPicker = document.querySelector('variant-picker');
// // //   if (!variantPicker) return;

// // //   const form = variantPicker.querySelector('.variant-picker__form');
// // //   if (!form) return;

// // //   const selectedVariantScript = form.querySelector('script[type="application/json"]');
// // //   const allVariantsScript = document.getElementById('all-variants-json');
// // //   const allMediaScript = document.getElementById('product-media-json');

// // //   if (!selectedVariantScript || !allVariantsScript || !allMediaScript) return;

// // //   const selectedVariant = JSON.parse(selectedVariantScript.textContent);
// // //   const allVariants = JSON.parse(allVariantsScript.textContent);
// // //   const allMedia = JSON.parse(allMediaScript.textContent);

// // //   const mediaGallery = document.querySelector('slideshow-component, .media-gallery, .product-media-list');
// // //   if (!mediaGallery) return;

// // //   const thumbSelectors = [
// // //     '.slideshow-controls__thumbnails',
// // //     '.slideshow-controls__thumbnails-container',
// // //     '.thumbnail-slider',
// // //     'slider-component',
// // //     '.dialog-thumbnails-list'
// // //   ];

// // //   function findThumbContainer() {
// // //     for (const s of thumbSelectors) {
// // //       const el = document.querySelector(s);
// // //       if (el) return el;
// // //     }
// // //     return null;
// // //   }

// // //   let thumbContainer = findThumbContainer();

// // //   function normalizeUrl(url = '') {
// // //     try {
// // //       let u = url.split('?')[0];
// // //       u = u.replace(/^https?:/, '').replace(/^\/\//, '');
// // //       u = u.replace(/#.*$/, '').trim();
// // //       return u;
// // //     } catch (e) {
// // //       return url;
// // //     }
// // //   }

// // //   const mapFull = new Map();
// // //   const mapFile = new Map();

// // //   (allMedia || []).forEach((m) => {
// // //     const preview = m.preview_image && (m.preview_image.src || m.preview_image.url || m.preview_image);
// // //     if (!preview) return;

// // //     const norm = normalizeUrl(preview);
// // //     mapFull.set(norm, m.id);

// // //     const parts = norm.split('/');
// // //     const fname = parts[parts.length - 1] || '';
// // //     if (fname) {
// // //       mapFile.set(fname, m.id);
// // //       const fnameNoQuery = fname.split('?')[0];
// // //       if (fnameNoQuery) mapFile.set(fnameNoQuery, m.id);
// // //     }
// // //   });

// // //   function mapSlidesAndThumbs() {
// // //     const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));
// // //     const thumbs = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnails button'));

// // //     function setMediaId(el) {
// // //       if (el.dataset?.mediaId) return;

// // //       const img = el.querySelector('img');
// // //       if (!img) return;

// // //       const src = img.currentSrc || img.src || img.getAttribute('src') || '';
// // //       const norm = normalizeUrl(src);
// // //       const file = norm.split('/').pop();

// // //       let id = mapFull.get(norm) || mapFile.get(file);
// // //       if (!id) {
// // //         // fallback match
// // //         for (const [k, v] of mapFull.entries()) {
// // //           if (k.includes(file)) {
// // //             id = v;
// // //             break;
// // //           }
// // //         }
// // //       }

// // //       if (id) {
// // //         el.dataset.mediaId = id;
// // //       } else {
// // //         console.warn('[Thumbnail Mapping] Could not map media ID for', el, src);
// // //       }
// // //     }

// // //     slides.forEach(setMediaId);
// // //     thumbs.forEach(setMediaId);
// // //   }

// // //   function getCurrentOptions() {
// // //     const options = [];
// // //     form.querySelectorAll('select[name^="options["]').forEach((select) => options.push(select.value));
// // //     form.querySelectorAll('input[type="radio"]:checked').forEach((radio) => options.push(radio.value));
// // //     return options;
// // //   }

// // //   function getSelectedVariant() {
// // //     const currentOptions = getCurrentOptions();
// // //     return allVariants.find((variant) =>
// // //       variant.options.every((opt, index) => opt === currentOptions[index])
// // //     );
// // //   }

// // //   function getVariantMediaIds(variant) {
// // //     if (!variant) return [];

// // //     const ids = new Set();

// // //     // Add featured media, image, and image_id
// // //     if (variant.featured_media?.id) ids.add(Number(variant.featured_media.id));
// // //     if (variant.image?.id) ids.add(Number(variant.image.id));
// // //     if (variant.image_id) ids.add(Number(variant.image_id));

// // //     // Add any media attached to this variant
// // //     (allMedia || []).forEach((m) => {
// // //       const attachedIds = m.attached_variant_ids || m.attached_to_variant_ids || m.associated_variant_ids || m.variant_ids;
// // //       if (Array.isArray(attachedIds) && attachedIds.includes(variant.id)) {
// // //         ids.add(Number(m.id));
// // //       }
// // //     });

// // //     return Array.from(ids);
// // //   }

// // //   function disableSliderAfterRender() {
// // //     const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));

// // //     document.querySelectorAll('.slideshow-control, .slideshow-controls__arrows, .slideshow-controls__arrow').forEach(el => el.remove());
// // //     slides.forEach(slide => slide.style.pointerEvents = 'none');

// // //     if (mediaGallery) {
// // //       mediaGallery.style.pointerEvents = 'none';
// // //       mediaGallery.addEventListener('wheel', e => e.stopImmediatePropagation(), { capture: true });
// // //       mediaGallery.addEventListener('touchstart', e => e.stopImmediatePropagation(), { capture: true });
// // //       mediaGallery.addEventListener('touchmove', e => e.stopImmediatePropagation(), { capture: true });
// // //     }

// // //     const slider = mediaGallery.slider || mediaGallery.__slider__;
// // //     if (slider && typeof slider.destroy === 'function') {
// // //       slider.destroy();
// // //     }
// // //   }

// // //   function updateMediaGallery(variant) {
// // //     if (!variant) return;

// // //     mapSlidesAndThumbs(); // ensure mediaId mapping

// // //     const variantMediaIds = getVariantMediaIds(variant);
// // //     const fallbackShowFirst = variantMediaIds.length === 0;

// // //     const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));
// // //     const thumbs = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnails button'));

// // //     slides.forEach((slide, idx) => {
// // //       const mid = Number(slide.dataset.mediaId);
// // //       slide.style.display = fallbackShowFirst ? (idx === 0 ? '' : 'none') : (variantMediaIds.includes(mid) ? '' : 'none');
// // //     });

// // //     thumbs.forEach((thumb, idx) => {
// // //       const mid = Number(thumb.dataset.mediaId);
// // //       thumb.style.display = fallbackShowFirst ? (idx === 0 ? '' : 'none') : (variantMediaIds.includes(mid) ? '' : 'none');
// // //     });

// // //     disableSliderAfterRender();
// // //   }

// // //   function scheduleApply() {
// // //     setTimeout(() => {
// // //       const variant = getSelectedVariant() || selectedVariant;
// // //       updateMediaGallery(variant);
// // //     }, 100); // allow DOM to update
// // //   }

// // //   // Event Listeners
// // //   form.addEventListener('change', scheduleApply);
// // //   variantPicker.addEventListener('change', scheduleApply);
// // //   variantPicker.addEventListener('variant:change', scheduleApply);

// // //   // Observer for DOM changes (lazy-load, etc.)
// // //   thumbContainer = thumbContainer || findThumbContainer();
// // //   const toObserve = [mediaGallery, thumbContainer, document.body].filter(Boolean);
// // //   const observer = new MutationObserver(scheduleApply);

// // //   toObserve.forEach(el => {
// // //     try {
// // //       observer.observe(el, { childList: true, subtree: true, attributes: true });
// // //     } catch (e) {}
// // //   });

// // //   // Initial trigger
// // //   scheduleApply();

// // //   console.log('[custom.js] init complete');
// // // });

// // document.addEventListener('DOMContentLoaded', function () {
// //   console.log('[custom.js] loaded with alt-based filtering');

// //   const variantPicker = document.querySelector('variant-picker');
// //   if (!variantPicker) return;

// //   const form = variantPicker.querySelector('.variant-picker__form');
// //   if (!form) return;

// //   const mediaGallery = document.querySelector('slideshow-component, .media-gallery, .product-media-list');
// //   if (!mediaGallery) return;

// //   const thumbSelectors = [
// //     '.slideshow-controls__thumbnails',
// //     '.slideshow-controls__thumbnails-container',
// //     '.thumbnail-slider',
// //     'slider-component',
// //     '.dialog-thumbnails-list'
// //   ];

// //   function findThumbContainer() {
// //     for (const s of thumbSelectors) {
// //       const el = document.querySelector(s);
// //       if (el) return el;
// //     }
// //     return null;
// //   }

// //   let thumbContainer = findThumbContainer();

// //   function getCurrentOptions() {
// //     const options = [];
// //     form.querySelectorAll('select[name^="options["]').forEach((select) => options.push(select.value));
// //     form.querySelectorAll('input[type="radio"]:checked').forEach((radio) => options.push(radio.value));
// //     return options;
// //   }

// //   function getSelectedColor() {
// //     const opts = getCurrentOptions();
// //     // assume first option is color; adjust index if needed
// //     return opts.length ? opts[0] : null;
// //   }

// //   function updateMediaGalleryByAlt(selectedColor) {
// //     if (!selectedColor) return;

// //     console.log('[custom.js] filtering for color:', selectedColor);

// //     const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));
// //     const thumbs = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnails button'));

// //     slides.forEach((slide, idx) => {
// //       const img = slide.querySelector('img');
// //       if (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) {
// //         slide.style.display = '';
// //       } else {
// //         slide.style.display = 'none';
// //       }
// //     });

// //     thumbs.forEach((thumb, idx) => {
// //       const img = thumb.querySelector('img');
// //       if (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) {
// //         thumb.style.display = '';
// //       } else {
// //         thumb.style.display = 'none';
// //       }
// //     });
// //   }

// //   function scheduleApply() {
// //     setTimeout(() => {
// //       const selectedColor = getSelectedColor();
// //       updateMediaGalleryByAlt(selectedColor);
// //     }, 100); // allow DOM to update
// //   }

// //   // Event Listeners
// //   form.addEventListener('change', scheduleApply);
// //   variantPicker.addEventListener('change', scheduleApply);
// //   variantPicker.addEventListener('variant:change', scheduleApply);

// //   // Observer for DOM changes (lazy-load, etc.)
// //   thumbContainer = thumbContainer || findThumbContainer();
// //   const toObserve = [mediaGallery, thumbContainer, document.body].filter(Boolean);
// //   const observer = new MutationObserver(scheduleApply);

// //   toObserve.forEach(el => {
// //     try {
// //       observer.observe(el, { childList: true, subtree: true, attributes: true });
// //     } catch (e) {}
// //   });

// //   // Initial trigger
// //   scheduleApply();

// //   console.log('[custom.js] init complete (alt-based)');
// // });

// document.addEventListener('DOMContentLoaded', function () {
//   console.log('[custom.js] loaded with alt-based filtering');

//   const variantPicker = document.querySelector('variant-picker');
//   if (!variantPicker) return;

//   const form = variantPicker.querySelector('.variant-picker__form');
//   if (!form) return;

//   const mediaGallery = document.querySelector('slideshow-component, .media-gallery, .product-media-list');
//   if (!mediaGallery) return;

//   const thumbSelectors = [
//     '.slideshow-controls__thumbnails',
//     '.slideshow-controls__thumbnails-container',
//     '.thumbnail-slider',
//     'slider-component',
//     '.dialog-thumbnails-list'
//   ];

//   function findThumbContainer() {
//     for (const s of thumbSelectors) {
//       const el = document.querySelector(s);
//       if (el) return el;
//     }
//     return null;
//   }

//   let thumbContainer = findThumbContainer();

//   function getCurrentOptions() {
//     const options = [];
//     form.querySelectorAll('select[name^="options["]').forEach((select) => options.push(select.value));
//     form.querySelectorAll('input[type="radio"]:checked').forEach((radio) => options.push(radio.value));
//     return options;
//   }

//   function getSelectedColor() {
//     const opts = getCurrentOptions();
//     // assume first option is color; adjust index if needed
//     return opts.length ? opts[0] : null;
//   }

//   function updateMediaGalleryByAlt(selectedColor) {
//     if (!selectedColor) return;

//     console.log('[custom.js] filtering for color:', selectedColor);

//     const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));
//     const thumbs = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnails button'));

//     let firstVisibleSlide = null;

//     slides.forEach((slide) => {
//       const img = slide.querySelector('img');
//       if (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) {
//         slide.style.display = '';
//         if (!firstVisibleSlide) firstVisibleSlide = slide;
//       } else {
//         slide.style.display = 'none';
//       }
//     });

//     thumbs.forEach((thumb) => {
//       const img = thumb.querySelector('img');
//       if (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) {
//         thumb.style.display = '';
//       } else {
//         thumb.style.display = 'none';
//       }
//     });

//     // Force slideshow to show the first matching slide only
//     if (firstVisibleSlide) {
//       const allSlides = slides.filter(s => s.style.display !== 'none');
//       allSlides.forEach(s => s.classList.remove('is-active')); // remove active classes
//       firstVisibleSlide.classList.add('is-active');

//       // scroll into view if slider is being used
//       if (firstVisibleSlide.scrollIntoView) {
//         firstVisibleSlide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'nearest' });
//       }
//     }
//   }

//   function scheduleApply() {
//     setTimeout(() => {
//       const selectedColor = getSelectedColor();
//       updateMediaGalleryByAlt(selectedColor);
//     }, 100); // allow DOM to update
//   }

//   // Event Listeners
//   form.addEventListener('change', scheduleApply);
//   variantPicker.addEventListener('change', scheduleApply);
//   variantPicker.addEventListener('variant:change', scheduleApply);

//   // Observer for DOM changes (lazy-load, etc.)
//   thumbContainer = thumbContainer || findThumbContainer();
//   const toObserve = [mediaGallery, thumbContainer, document.body].filter(Boolean);
//   const observer = new MutationObserver(scheduleApply);

//   toObserve.forEach(el => {
//     try {
//       observer.observe(el, { childList: true, subtree: true, attributes: true });
//     } catch (e) {}
//   });

//   // Initial trigger
//   scheduleApply();

//   console.log('[custom.js] init complete (alt-based)');
// });

// document.addEventListener('DOMContentLoaded', function () {
//   console.log('[custom.js] loaded – thumbnails only mode');

//   const disableSlider = () => {
//     const mediaGallery = document.querySelector('slideshow-component, .media-gallery, .product-media-list');
//     if (!mediaGallery) return;

//     // Hide arrows
//     document.querySelectorAll('.slideshow-control, .slideshow-controls__arrows, .slideshow-controls__arrow')
//       .forEach(el => el.style.display = 'none');

//     // Kill Shopify slider if present
//     const slider = mediaGallery.slider || mediaGallery.__slider__;
//     if (slider && typeof slider.destroy === 'function') {
//       slider.destroy();
//       console.log('[custom.js] slider destroyed');
//     }

//     // Disable scrolling/swiping
//     mediaGallery.style.pointerEvents = 'none';
//     mediaGallery.addEventListener('wheel', e => e.stopImmediatePropagation(), { capture: true });
//     mediaGallery.addEventListener('touchstart', e => e.stopImmediatePropagation(), { capture: true });
//     mediaGallery.addEventListener('touchmove', e => e.stopImmediatePropagation(), { capture: true });

//     // Allow thumbnails to still work
//     const thumbs = document.querySelectorAll('.slideshow-controls__thumbnail, .thumbnail-slider button, .dialog-thumbnails-list__thumbnail');
//     thumbs.forEach(thumb => {
//       thumb.style.pointerEvents = 'auto';
//     });

//     console.log('[custom.js] thumbnails-only mode applied');
//   };

//   // Run once on load
//   disableSlider();

//   // Watch for AJAX re-render (variant change updates DOM)
//   const observer = new MutationObserver(() => {
//     disableSlider();
//   });

//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });
document.addEventListener('DOMContentLoaded', function () {
  console.log('[custom.js] loaded – filtering images by color + keeping default variant image');

  const variantPicker = document.querySelector('variant-picker');
  if (!variantPicker) return;

  const form = variantPicker.querySelector('.variant-picker__form');
  if (!form) return;

  function getCurrentOptions() {
    const options = [];
    form.querySelectorAll('select[name^="options["]').forEach((select) => options.push(select.value));
    form.querySelectorAll('input[type="radio"]:checked').forEach((radio) => options.push(radio.value));
    return options;
  }

  function getSelectedColor() {
    const opts = getCurrentOptions();
    return opts.length ? opts[0] : null; // assume first option = color
  }

  function filterByAlt(selectedColor) {
    if (!selectedColor) return;

    const mediaGallery = document.querySelector('slideshow-component, .media-gallery, .product-media-list');
    if (!mediaGallery) return;

    const slides = Array.from(mediaGallery.querySelectorAll('slideshow-slide, .product-media-container, .product-media'));
    const thumbs = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail, .slideshow-controls__thumbnails button'));

    // Find the default variant image (Shopify marks it as is-active or first visible)
    const defaultSlide = mediaGallery.querySelector('slideshow-slide[aria-hidden="false"], .product-media-container.is-active, .product-media:first-child');
    let defaultSrc = null;
    if (defaultSlide) {
      const img = defaultSlide.querySelector('img');
      if (img) defaultSrc = img.src;
    }

    slides.forEach(slide => {
      const img = slide.querySelector('img');
      if (
        (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) ||
        (img && defaultSrc && img.src === defaultSrc)
      ) {
        slide.style.display = '';
      } else {
        slide.style.display = 'none';
      }
    });

    thumbs.forEach(thumb => {
      const img = thumb.querySelector('img');
      if (
        (img && img.alt.toLowerCase() === selectedColor.toLowerCase()) ||
        (img && defaultSrc && img.src === defaultSrc)
      ) {
        thumb.style.display = '';
      } else {
        thumb.style.display = 'none';
      }
    });

    console.log(`[custom.js] filtered for: ${selectedColor}, kept default image: ${defaultSrc}`);
  }

  // Run on first load
  filterByAlt(getSelectedColor());

  // Observe changes to the product area (Shopify replaces it via AJAX)
  const target = document.querySelector('.product, product-info, body');
  if (target) {
    const observer = new MutationObserver(() => {
      const selectedColor = getSelectedColor();
      if (selectedColor) {
        setTimeout(() => filterByAlt(selectedColor), 200);
      }
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }
});
